import Vue from 'vue'
import App from './App.vue'
import router from './router'
import toast from '@/utils/toast'

Vue.config.productionTip = false

// 将 toast 挂载到 Vue 原型
Vue.prototype.$toast = toast

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
